import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { has } from 'lodash';

import { HHAlert } from '../common/util';
import { ALERT_TYPE } from '../common/constant';

class AccountVerified extends React.Component {
  alertUserToVerifyEmail = () => {
    HHAlert({ id: 'alert.error.emailOrPhoneNotVerified' }, ALERT_TYPE.ERROR);
  };

  render() {
    const { user, children } = this.props;

    let verified = !user.isLoggedIn;
    if (has(user, 'profile.basicInfo')) {
      const { isEmailVerified, isPhoneVerified } = user.profile.basicInfo;
      verified = isEmailVerified || isPhoneVerified;
    }

    return (
      <Fragment>
        { children({
          verified,
          alertUserToVerifyEmail: this.alertUserToVerifyEmail
        }) }
      </Fragment>
    );
  }
}

export default connect(({ user }) => ({ user }))(AccountVerified);



// WEBPACK FOOTER //
// ./src/components/common/accountVerified.js